import { Link } from 'react-router-dom';
import { FileText, Shield, Lock, ExternalLink } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-slate-50 border-t border-slate-200 mt-auto">
      <div className="container-app py-8 md:py-12">
        {/* Trust badges */}
        <div className="flex flex-wrap justify-center gap-6 mb-8 pb-8 border-b border-slate-200">
          <div className="flex items-center gap-2 text-slate-600 text-sm">
            <Shield className="w-4 h-4 text-green-600" />
            <span>Documents conformes</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 text-sm">
            <Lock className="w-4 h-4 text-green-600" />
            <span>Paiement sécurisé</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 text-sm">
            <FileText className="w-4 h-4 text-green-600" />
            <span>Téléchargement immédiat</span>
          </div>
        </div>
        
        {/* Contact / Support */}
        <div className="text-center mb-8 pb-8 border-b border-slate-200">
          <p className="text-slate-700 font-medium mb-2">Besoin d'aide ?</p>
          <p className="text-slate-600 text-sm">
            Une question ou un problème avec votre document ?<br />
            Contactez-nous à : <a href="mailto:contact@pdf-facile.fr" className="text-primary hover:underline">contact@pdf-facile.fr</a>
          </p>
        </div>
        
        {/* Links */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-8 text-sm">
          <Link 
            to="/mentions-legales" 
            className="text-slate-600 hover:text-primary"
            data-testid="footer-mentions-legales"
          >
            Mentions légales
          </Link>
          <Link 
            to="/conditions-utilisation" 
            className="text-slate-600 hover:text-primary"
            data-testid="footer-cgu"
          >
            Conditions d'utilisation
          </Link>
          <Link 
            to="/confidentialite" 
            className="text-slate-600 hover:text-primary"
            data-testid="footer-confidentialite"
          >
            Politique de confidentialité
          </Link>
        </div>
        
        {/* CFE Auto-entrepreneur */}
        <div className="text-center mb-6 pb-6 border-b border-slate-200">
          <p className="text-slate-600 text-sm mb-2">
            🏢 <strong>Auto-entrepreneur ?</strong> Générez votre déclaration CFE (formulaire 1447-C-SD).
          </p>
          <a
            href="https://cfe-autoentrepreneur.fr"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-primary hover:underline text-sm font-medium"
          >
            cfe-autoentrepreneur.fr <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center text-sm text-slate-500">
          <p>© {currentYear} PDF Facile. Tous droits réservés.</p>
          <p className="mt-1">Générateur de documents administratifs français.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
